import * as React from "react";
import Axios from "axios";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";

import {
  FORBIDDEN_ERROR_CODE,
  UNAUTHORIZED_ERROR_CODE,
  UNFOUND_ROUTE,
} from "app/constants/variables";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: process.env.NODE_ENV === "production",
      retry(failureCount, error) {
        if (failureCount >= 3) {
          return false;
        }

        if (!Axios.isAxiosError(error)) {
          return true;
        }

        const canRetry = Boolean(
          error.response &&
            ![
              UNAUTHORIZED_ERROR_CODE,
              UNFOUND_ROUTE,
              FORBIDDEN_ERROR_CODE,
            ].includes(error.response.status)
        );
        return canRetry;
      },
    },
  },
});

export default function QueryProvider(props: React.PropsWithChildren<{}>) {
  return (
    <QueryClientProvider client={queryClient}>
      {props.children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
}
